import { UseGlobalLoading } from "Hooks/UseGlobalLoading";

import Button from "Components/Admin/Buttons";
import Table from "Components/Admin/Table";

import * as S from "./styles";

const UsersSearch = ({
  users,
  selectedUsers,
  setSelectedUsers,
  getUsers,
  setUsers,
}) => {
  const { loading } = UseGlobalLoading();

  const searchUsers = async () => {
    setUsers([]);
    await getUsers(setUsers, selectedUsers);
  };

  const columns = [
    {
      Header: "Nome",
      accessor: "full_name",
    },
  ];

  const defaultSelectedRows = (state) => {
    const obj = {};

    for (let i = 0; i < state.length; i++) {
      obj[i] = true;
    }

    return obj;
  };

  const onSelectChange = (selected) => {
    setSelectedUsers(selected);
  };

  return (
    <S.Wrapper>
      <S.FormWrapper>
        <h1>Usuários</h1>
        <Button
          type="button"
          text="Buscar"
          onClick={searchUsers}
          disabled={loading}
        />
      </S.FormWrapper>

      {users.length > 0 && (
        <S.Table>
          <Table
            defaultSelectedRowIds={defaultSelectedRows(selectedUsers)}
            columns={columns}
            data={users}
            download={false}
            selectable={true}
            onSelectChange={onSelectChange}
          />
        </S.Table>
      )}
    </S.Wrapper>
  );
};

export default UsersSearch;
